// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementReportDashboardUpdateDashboardResult = objectOf({
  id: string,
  name: string,
  dashboard_type: nullOrUndefined,
  grid_layout: arrayOf(
    objectOf({
      i: string,
      x: number,
      y: number,
      w: number,
      h: number,
      minW: number,
      minH: number,
      static: boolean,
    })
  ),
  tile_data_queries: arrayOf(
    objectOf({
      id: string,
      _id: string,
      sql: string,
      query_builder_id: string,
      query_builder_name: string,
    })
  ),
  tiles: arrayOf(
    objectOf({
      id: string,
      company_id: string,
      app_group_id: string,
      developer_id: string,
      dashboard_id: string,
      tile_data_query_id: string,
      x_axis: string,
      group_by: string,
      chart_type: string,
      title: string,
      ignore_columns: arrayOf(nullOrUndefined),
    })
  ),
  variables: arrayOf(nullOrUndefined),
  version: string,
  archived_at: maybe(string, true),
  archived_by: maybe(string, true),
});

// This represents a HEAD 204 No Content response
export const isEngagementReportDashboardDeleteDashboardResult = objectOf({});
